export const URI_OFFER = 'offer';
